export default __webpack_public_path__ + "static/placeholder-489e65b3f87a7e32ddb25f0b6252921c.jpg";